let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("01akX")).then(() => parcelRequire('7jsM3'));